import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: () => import("@/views/main/index.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/main/_home.vue")
      },
      {
        path: "/home",
        component: () => import("@/views/main/_home.vue")
      },
      {
        path: "/aboutus",
        component: () => import("@/views/main/_general.vue")
      },
      {
        path: "/privacypolicy",
        component: () => import("@/views/main/_general.vue")
      },
      {
        path: "/responsiblegaming",
        component: () => import("@/views/main/_general.vue")
      },
      {
        path: "/banking",
        component: () => import("@/views/main/_general.vue")
      },
      {
        path: "/faqs",
        component: () => import("@/views/main/_general.vue")
      },
      {
        path: "/registration",
        component: () => import("@/views/main/_registration.vue")
      },
      {
        path: "/deposit",
        component: () => import("@/views/main/_deposit.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/withdraw",
        component: () => import("@/views/main/_withdraw.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/transfer",
        component: () => import("@/views/main/_transfer.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/rebate",
        component: () => import("@/views/main/_rebate.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/statement",
        component: () => import("@/views/main/_statement.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/account",
        component: () => import("@/views/main/_account.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/promo",
        component: () => import("@/views/main/_promo.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/live22",
        component: () => import("@/components/slots/_live22.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/live22fish",
        component: () => import("@/components/fishing/_live22.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/uu",
        component: () => import("@/components/slots/_uuslot.vue"),
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/pps",
        component: () => import("@/components/slots/_pps.vue"),
        meta: { requiredLoggedIn: true}
      },
    ]
  },
  {
    path: "*",
    component: () => import("@/views/main/_errorPage.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
